module.exports = __webpack_public_path__ + "static/media/docker.1380befa.svg";